import { SceneState } from '../../../components/SceneStatemachinePlugin';
import { HUMALONG_VO } from '../config/config';

const STATE_INTRO = [
  { vo: 'humalong_instruction_1', character: true },
  { vo: 'humalong_instruction_3', character: true },
  { vo: 'humalong_instruction_4', character: true },
];

export class StateXylophoneSongIntro extends SceneState {
  constructor(scene) {
    super(scene);
  }

  startState() {
    this.stateVoIndex = 0;
    this.scene.setDisplayType('play', {
      onComplete: this.playNextStateVo,
      onCompleteScope: this,
    });
  }

  playNextStateVo() {
    this.scene.character.setTalking(true);
    this.scene.game.vo.playChain(HUMALONG_VO.start_interaction, {
      onComplete: this.handleStateVoComplete.bind(this),
    });
  }
  handleStateVoComplete() {
    this.scene.character.setTalking(false);
    this.emit('state_complete');
  }
}
